import { render } from "./DefTitle.vue?vue&type=template&id=51570cfa&scoped=true"
import script from "./DefTitle.vue?vue&type=script&lang=js"
export * from "./DefTitle.vue?vue&type=script&lang=js"

import "./DefTitle.vue?vue&type=style&index=0&id=51570cfa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51570cfa"]])

export default __exports__